import {Card} from 'platform/components';
import {Box, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

export interface SectionProps extends RequiredTestIdProps {
  title?: string;
  children: ReactNode;
  isExpandable?: boolean;
  actions?: React.ComponentProps<typeof Card>['actions'];
}

/**
 * Section primitive - provides consistent Card wrapper for form sections
 *
 * @example
 * <Section title="Basic Information">
 *   <Field name="vin" />
 *   <Field name="make" />
 * </Section>
 */
export function Section(props: SectionProps) {
  const {title, children, isExpandable, actions, ...testIdProps} = props;

  return isExpandable ? (
    <Card
      title={title}
      isExpandable={isExpandable}
      actions={actions}
      data-testid={suffixTestId('section', testIdProps)}
    >
      <VStack spacing={4}>{children}</VStack>
    </Card>
  ) : (
    <Box padding={4}>
      <VStack spacing={4}>{children}</VStack>
    </Box>
  );
}
